module.exports = __webpack_public_path__ + "img/nabl_gallery9.f014b3bc.jpg";